import { mapGetters } from "vuex";
import localStorageService from "@/core/services/localStorage.service";
import moduleUser, {SELF, MODULE_NAME as USER_MODULE} from "@/core/services/store/user.module";
import store from "@/core/services/store";

const _USER_MODULE = USER_MODULE;
const IS_SUPER_ADMIN = 'Staff:superAdmin';
const TECHNICIAN_STAFF = 'Staff:technician';
const CUSTOMER_STAFF = 'Staff:customer';
const OPERATOR_STAFF = 'Staff:operator';
const STORE_STAFF = 'Staff:store';

export default {
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_USER_MODULE, moduleUser);
  },
  computed: {
    ...mapGetters({
      layoutConfig: "layoutConfig"
    }),
    systemLanguages () {
      let item =  localStorage.getItem("languages");
      if (item) {
        return JSON.parse(item);
      }
      return [];
    },
    pdfImageIconUrl () {
      return process.env.VUE_APP_BACKEND_APP_URL + '/icons/pdf-icon.png';
    },
    fileImageIconUrl () {
      return process.env.VUE_APP_BACKEND_APP_URL + '/icons/file-icon.png';
    },
    authUser() {
      let user = this.$store.getters[_USER_MODULE + '/' + SELF];

      return user && user.hasOwnProperty('user') ? user.user  : null;
    },
    authUserScopes() {
      let user = this.$store.getters[_USER_MODULE + '/' + SELF];
      return user && user.hasOwnProperty('scopes') ? user.scopes : null;
    },

    isSuperAdmin() {
      if (this.authUserScopes) {
        let model = IS_SUPER_ADMIN.split(":")[0];
        let action = IS_SUPER_ADMIN.split(":")[1];
        return !!this.authUserScopes.find(subItem => subItem.model === model && subItem.action === action);
      }
      return false;
    },
    isCustomer() {
      if (this.authUserScopes) {
        let model = CUSTOMER_STAFF.split(":")[0];
        let action = CUSTOMER_STAFF.split(":")[1];
        return !!this.authUserScopes.find(subItem => subItem.model === model && subItem.action === action);
      }
      return false;
    },
    isOperator() {
      if (this.authUserScopes) {
        let model = OPERATOR_STAFF.split(":")[0];
        let action = OPERATOR_STAFF.split(":")[1];
        return !!this.authUserScopes.find(subItem => subItem.model === model && subItem.action === action);
      }
      return false;
    },
    isTechnician() {
      if (this.authUserScopes) {
        let model = TECHNICIAN_STAFF.split(":")[0];
        let action = TECHNICIAN_STAFF.split(":")[1];
        return !!this.authUserScopes.find(subItem => subItem.model === model && subItem.action === action);
      }
      return false;
    },
    isStore() {
      if (this.authUserScopes) {
        let model = STORE_STAFF.split(":")[0];
        let action = STORE_STAFF.split(":")[1];
        return !!this.authUserScopes.find(subItem => subItem.model === model && subItem.action === action);
      }
      return false;
    }
  },
  methods: {
    isImage(mimeType) {
      if (mimeType) {
        let tmpResult = _.first(mimeType.split("/"))

        if (tmpResult === 'image') {
          return true;
        }

      return false;
      }

      return true;
    },
    isPdf(mimeType) {
      if (mimeType && mimeType === 'application/pdf') {
        return true;
      }

      return false;
    },
    isVideo(mimeType) {
      if (mimeType) {
        let tmpResult = _.first(mimeType.split("/"))

        if (tmpResult === 'video') {
          return true;
        }

        return false;
      }

      return true;
    },
    isUserGranted() {
      let self = this;
      try {
        let resultStatus = false;
        let authUserLocal = localStorageService.get('user') ? JSON.parse(localStorageService.get('user')) : null;
        let authUserState = self.authUser;
        let authUser = authUserState || authUserLocal;
        return function (module, actions, _showModal = true) {
          if (!authUser) {
            return false;
          }

          // checking user is super admin
          let isSuperAdmin = authUser.scopes.find(subItem => subItem.model === 'Staff' && subItem.action === 'superAdmin');

          if (isSuperAdmin) {
            resultStatus = true;
            return true;
          }

          actions = actions.map(action => _.lowerCase(action));
          let scopes = _.map(authUser.scopes.filter(subItem => _.lowerCase(subItem.model) === _.lowerCase(module)), 'action');

          if (scopes.includes('all')) {
            resultStatus = true;
            return true;
          } else {
            let item =  scopes.find(item => actions.includes(_.lowerCase(item)));
            if (item) {
              resultStatus = true;
            } else {
              resultStatus = false;
            }
          }

          if (!resultStatus && _showModal) {
            setTimeout(() => {
              self.sweetAlertError(this.$t('general.you_have_no_authorized_to_do_this_action'));
            }, 500);
          }

          return resultStatus;
        }
      } catch (e) {
        return false;
      }
    },
    apiResponseError (payload) {
      if (!payload) {
        return payload
      }

      let errorData;
      if (payload.status === 422) {
        errorData = payload.data;
      } else {
        errorData = payload.response !== undefined ? payload.response.data : payload;
      }

      if (typeof errorData === 'string') {
        return errorData
      } else {
        let errorMessage = ''
        if (errorData && errorData.errors) {
          let messageArray = Object.values(errorData.errors)[0]
          errorMessage = messageArray[0]
        } else if (errorData && errorData.message) {
          errorMessage = errorData.message
        } else {
          let messageArray = Object.values(errorData)[0]
          errorMessage = messageArray[0]
        }
        return this.$t(errorMessage);
      }
    },
    getImageLink(imageLink) {
      if (imageLink) {
        return process.env.VUE_APP_BACKEND_APP_URL + "" + imageLink + ".png";
      }
      return process.env.VUE_APP_BACKEND_APP_URL + "/uploads/no-photo.png";
    },
    getIconByKey(key, configs = null) {
      if (configs) {
        return `<img 
                            src="${process.env.BASE_URL +
                              this.layoutConfig(key)}" 
                            class="${configs.class ||
                              "w-25px h-25px object-cover mr-2"}"
                            style="${configs.style || ""}"
                        >`;
      }
      return process.env.BASE_URL + this.layoutConfig(key);
    },
    getProductTypeIconById(id) {
      let icons = {
        "1": "fas fa-tshirt",
        "2": "flaticon-squares",
        "3": "fas fa-ring"
      };

      return icons[id.toString()];
    },
    closeModalByName(name) {
      this.$modal.hide(name);
    },
    openModalByName(name) {
      this.$modal.show(name);
    },
    showSuccessNotification() {
      let successMessage = this.$route.params.success;
      if (successMessage != null) {
        this.$notify({
          group: "notification",
          class: "bg-success",
          title: this.$t("general.success"),
          position: "bottom right",
          text: successMessage
        });
      }
    },
    showErrorNotification() {
      let errorMessage = this.$route.params.error;
      if (errorMessage != null) {
        this.$notify({
          group: "notification",
          class: "bg-error",
          title: this.$t("general.error"),
          position: "bottom right",
          text: this.$t(errorMessage)
        });
      }
    },
    getLanguageById(id) {
      let languages = JSON.parse(localStorage.getItem("languages"));
      for (let i = 0; i < languages.length; i++) {
        if (
          Number(languages[i].id === Number(id)) ||
          languages[i].code.toString() === id.toString()
        ) {
          return languages[i];
        }
      }
      return null;
    },
    getValueByDottedKey(object, key) {
      let temp = { ...object };
      try {
        let splitKeys = key.split(".");
        for (let i = 0; i < splitKeys.length; i++) {
          temp = temp[splitKeys[i]];
        }
      } catch (e) {
        console.log({ object, key });
        console.error(e);
        return "";
      }
      return temp;
    },
    capitalize(string) {
      let pieces = string.split(" "),
        result = "";
      for (let i = 0; i < pieces.length; i++) {
        result +=
          pieces[i].charAt(0).toUpperCase() + pieces[i].slice(1).toLowerCase();
        if (pieces.length - 1 !== i) {
          result += " ";
        }
      }
      return result;
    },
    convertArrayToObjectByKey(array, key, keys = null) {
      let result = {};
      try {
        for (let i = 0; i < array.length; i++) {
          if (keys !== null) {
            if (keys.length === 1) {
              result[array[i][key]] = this.getValueByDottedKey(
                array[i],
                keys[0]
              );
            } else if (!Array.isArray(keys)) {
              result[array[i][key]] = this.getValueByDottedKey(array[i], keys);
            } else {
              let temp = {};
              for (let j = 0; j < keys.length; j++) {
                temp[keys[j]] = this.getValueByDottedKey(
                  array[i],
                  array[i][keys[j]]
                );
              }
              result[array[i][key]] = temp;
            }
          } else {
            result[array[i][key]] = array[i];
          }
        }
        return result;
      } catch (e) {
        console.log(e);
        return {};
      }
    },
    convertObjectToArray(object, key = null) {
      let result = [];
      try {
        for (let index in object) {
          if (key !== null) {
            result.push({ ...object[index], ...{ [key]: index } });
          } else {
            result.push({ ...object[index] });
          }
        }
        return result;
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    openInNewTab(url) {
      window.open(url, "_blank");
    },
    isUserInGivenRoles(roles) {
      return roles.includes(this.user().roles[0].id);
    },
    findSameRolesByIds(roles) {
      let user = JSON.parse(window.localStorage.getItem("user"));
      let role_ids = [];
      for (let i = 0; i < user.scopes.length; i++) {
        let temp = user.scopes[i];
        if (!role_ids.includes(Number(temp.role_user_id))) {
          role_ids.push(Number(temp.role_user_id));
        }
      }
      if (!Array.isArray(roles)) {
        roles = [roles];
      }
      let existedRoles = [];
      role_ids.every(i => {
        if (roles.includes(i)) {
          existedRoles.push(i);
        }
      });
      return existedRoles;
    },
    createFormDataForList(formData, key, data) {
      if (data === Object(data) || Array.isArray(data)) {
        for (let i in data) {
          if (i.toString() === "file_names") {
            continue;
          }
          if (data.file_names !== undefined) {
            if (data.file_names.includes(i)) {
              formData.append(key + "[" + i + "]", data[i]);
              continue;
            }
          }
          this.createFormDataForList(formData, key + "[" + i + "]", data[i]);
        }
      } else {
        formData.append(key, data);
      }
    }
  }
};
